//Main
import vue from "vue"
import vapi from "vuex-rest-api"
import vuex from "vuex"

vue.use(vuex);

//store
const util = new vapi({
    baseURL: `${process.env.VUE_APP_REST}/api/Util`,
    state: {
        Aroles: []
    }
}).get({
    action: "ClearCache",
    path:   function () {
        return "/ClearCache" ;
    }
}).getStore();

export default util;